var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"icon-height"},[_vm._v(_vm._s(_vm.$t('dashboard.seller.total_since_registration')))]),_c('h2',[_vm._v(_vm._s(_vm.total.totalVolume)+" "+_vm._s(_vm.currency))])])}
var staticRenderFns = []

export { render, staticRenderFns }